import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';

const CorporateLogoForm = ({ apiHandler, editData }) => {
    const initialValues = {
        name: editData?.name || '',
        image: editData?.image || '',
        status: editData ? editData?.status : 1,
    };

    const formHandler = (formValue) => {
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };
    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Corporate Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Corporate Logo' required />

                <ReactInput name='image' type='file' />
            </Form.Group>

            <StatusCheck />
        </CrudFormLayout>
    );
};

export default CorporateLogoForm;
